import { render, staticRenderFns } from "./AMQ.vue?vue&type=template&id=4479cc9a&"
import script from "./AMQ.vue?vue&type=script&lang=js&"
export * from "./AMQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports